<template>
  <div>
    <div>Доступные инструменты</div>
    <div class="instrumentsDiv__instruments" v-if="tools">
      <b-button
        v-for="tool in tools"
        :key="tool.name"
        class="mr-2"
        @click="changeInstrument(tool)"
        :variant="buttonVariant(tool)"
      >
        <img
          :src="resources.imagesById[tool.textureId].src"
          class="instrumentsDiv__image"
          v-b-tooltip.hover
          :title="tool.name"
        />
      </b-button>
    </div>
    <div class="instrumentsDiv__instruments" v-else>
      Инструментов нет
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ToolsSelector',
  props: {
    value: {
      required: true
    },
    panel: {
      type: Object,
      required: true
    }
  },
  model: {
    event: 'change'
  },
  computed: {
    ...mapGetters({
      resources: 'training/getResources'
    }),
    tools() {
      return this.panel.tools
    }
  },
  methods: {
    changeInstrument(tool) {
      this.$emit('change', tool)
    },
    buttonVariant(tool) {
      let style = 'secondary'
      if (this.value) {
        style = tool.name === this.value.name ? 'primary' : 'secondary'
      }
      return style
    }
  }
}
</script>

<style scoped>
.instrumentsDiv__instruments {
  border: solid 1px black;
  height: 55px;
}

.instrumentsDiv__image {
  display: block;
  height: 39px;
  width: auto;
}
</style>
